
 var owl = $('.owl-carousel2');
owl.owlCarousel({
   loop:true,
   nav: true,
   dots: true,
   items: 1,
   margin: 15,
   lazyLoad: true,
  responsive:{	
320:{
items:3,
  margin: 10
},

678:{
items:6
},

960:{
items:8
}
}
});

  
   
 var owl = $('.owl-carousel3');
owl.owlCarousel({
   loop:false,
   nav: false,
   dots: false,
   items: 1,
   margin: 15,
   lazyLoad: true,
  responsive:{	
320:{
items:2,
  margin: 10
},

678:{
items:1
},

960:{
items:1
}
}
});

    
 var owl = $('.owl-carousel4');
owl.owlCarousel({
   loop:true,
   nav: true,
   dots: true,
   items: 1,
   margin: 15,
   lazyLoad: true,
  responsive:{	
320:{
items:2,
  margin: 10
},

678:{
items:2
},

960:{
items:2
}
}
});

     
 var owl = $('.owl-carousel5');
owl.owlCarousel({
   loop:true,
   nav: true,
   dots: true,
   items: 1,
   margin: 15,
   lazyLoad: true,
  responsive:{	
320:{
items:2,
  margin: 10
},

678:{
items:3
},

960:{
items:3
}
}
});


 var owl = $('.owl-carousel');
owl.owlCarousel({
   loop:true,
   nav: true,
   dots: false,
   items: 1,
   margin: 15,
   lazyLoad: true,
  responsive:{	
320:{
items:2,
  margin: 10
},

678:{
items:3
},

960:{
items:4
}
}
});
